import {
    GET_ORGANISATIONS_REQUEST,
    GET_ORGANISATIONS_ERROR,
    GET_ORGANISATIONS_SUCCESS,
    SET_DATA_IS_OBJECT
  } from "../../actions/types";
  
  const initialState = {};
  
  export default (state = initialState, action) => {
    switch (action.type) {
  
      case GET_ORGANISATIONS_REQUEST:
        return {
          ...state,
          isFetching: true,
          error: undefined
        };
  
      case GET_ORGANISATIONS_SUCCESS:
        return {
          ...state,
          organisations: action.payload,
          isFetching: false,
          error: undefined
        };
  
      case GET_ORGANISATIONS_ERROR:
        return {
          organisations: {},
          isFetching: false,
          error: `${action.error}`
        };

      case SET_DATA_IS_OBJECT:
        return {
          ...state,
          dataIsObject: action.isObject
        };
  
      default:
        return state;
    }
  };
  